import React from 'react';
import { achievements } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Award, Trophy, Medal, Star, Users2 } from 'lucide-react';
import { Badge } from './ui/badge';

const Achievements = () => {
  const getIcon = (category) => {
    switch (category) {
      case 'Award':
        return Award;
      case 'Fellowship':
        return Star;
      case 'Competition':
        return Trophy;
      case 'Research':
        return Medal;
      case 'Leadership':
        return Users2;
      default:
        return Award;
    }
  };

  return (
    <section id="achievements" className="py-20 px-4 bg-gradient-to-b from-teal-50 to-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Awards & Recognition
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Honored for excellence in cancer care, research, and patient service
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {achievements.map((achievement) => {
            const Icon = getIcon(achievement.category);
            return (
              <Card key={achievement.id} className="hover:shadow-lg transition-all duration-300 hover:-translate-y-1">
                <CardContent className="pt-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                      <Icon className="w-6 h-6 text-yellow-600" />
                    </div>
                    <div className="flex-1">
                      <div className="flex items-center gap-2 mb-2">
                        <span className="text-sm font-semibold text-teal-700">{achievement.year}</span>
                        <Badge variant="secondary" className="text-xs">{achievement.category}</Badge>
                      </div>
                      <h3 className="text-lg font-bold text-gray-900 mb-2">{achievement.title}</h3>
                      <p className="text-sm text-gray-600 leading-relaxed">{achievement.description}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Achievements;